/* eslint-disable jsx-a11y/no-redundant-roles */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-undef */
import React from 'react';
import Api from '../Server/Api';

const api = new Api();

export const FieldInput = ({ type = "text", icon, placeholder, value, callback }) => {
    return (
        <div className="field">
        <div className={`control ${icon ? "has-icon" : ""}`}>
            <input
                className="input"
                type={type}
                placeholder={placeholder}
                defaultValue={value}
                onInput={e => callback && callback(e.target.value)}
            />
            {icon && (
                <span className="form-icon">
                {/* <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="feather feather-lock"
                >
                    <rect x={3} y={11} width={18} height={11} rx={2} ry={2} />
                    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                </svg> */}
                {icon && icon()}
            </span>
            )}
        </div>
    </div>
    )
}

export const TextArea = ({ value, placeholder="", callback }) => {
    return (
        <div className="field">
  <div className="control">
    <textarea className="textarea" rows={4} placeholder={placeholder}  defaultValue={value}
        onInput={e => callback && callback(e.target.value)}
    />
  </div>
</div>

    )
}





export const Button = ({ callback, text="Continue", loading}) => {
    return (
        <button className={`button h-button is-primary is-bold is-fullwidth is-raised ${loading ? "is-loading":""}`}
            onClick={(e) => {
                e.preventDefault();
                callback && callback()
            }}
        >
            {text}
        </button>
    )
}


export const DropifyInput = ({
    url,
    type,
    callback,
    allowed,
    label,
    required,
}) => {

    React.useEffect(() => {
        try {
            $(".dropify").dropify();
        } catch (error) {
            console.log(error)
        }
    }, []);

    const onFileChange = (e) => {
        let files = e.target.files || e.dataTransfer.files;
        if (!files.length) return;
        createImage(files[0]);
    };

    const createImage = (file) => {
        let reader = new FileReader();
        reader.onload = (e) => {
            callback(e.target.result);
        };
        reader.readAsDataURL(file);
    };

    return (
        <div className="form-group">
            {label && (
                <label htmlFor="exampleInputPassword1">
                    {label}
                    {required && <span className="text-danger">*</span>}
                </label>
            )}
            <input
                type={type || "file"}
                data-show-errors="true"
                onChange={(e) => onFileChange(e)}
                className="dropify"
                data-default-file={url}
                data-max-file-size-preview="3M"
                data-allowed-file-extensions={
                    allowed || "pdf png jpg jpeg doc docx xls csv"
                }
            />
        </div>
    );
};


export const ImageUpload = ({ title, value, description, callback, readOnly }) => {


    const [show, setShow] = React.useState(false);
    const [image, setImage] = React.useState();

    const onFileChange = (e) => {
        let files = e.target.files || e.dataTransfer.files;
        if (!files.length) return;
        createImage(files[0]);
    };

    const createImage = (file) => {
        let reader = new FileReader();
        reader.onload = (e) => {
            callback && callback(e.target.result);
			setImage(e.target.result)
			setShow(false)
        };
        reader.readAsDataURL(file);
    };

	const uploadInput = React.useRef(null);

    return (
			<div className="fieldset upload">
				<div className="fieldset-heading">
					{title && <h4>{title}</h4>}
					{description && <p>{description}</p>}
				</div>
				<div
					className="h-avatar profile-h-avatar is-xl"
					style={{ minWidth: "100%" }}
				>
					<img
						className={`avatar upload ${show ? "is-hidden" : ""}`}
						src={image || value || "https://via.placeholder.com/450x450"}
						// data-demo-src={value||"assets/img/avatars/photos/8.jpg"}
						alt=""
					/>

					<div className={`filepond-profile-wrap ${show ? "" : "is-hidden"}`}>
						<div
							className="filepond--root profile-filepondx filepond--hopper"
							style={{ height: 150 }}
						>
							<input
								ref={uploadInput}
								className="filepond--browser"
								type="file"
                                onChange={(e) => {
									onFileChange(e);
								}}
							/>
							<div
								className="filepond--drop-label"
								style={{ 
                                    transform: "translate3d(0px, 0px, 0px)", 
                                    opacity: 1 ,
                                    backgroundImage: (value||image) ? `url(${value||image})` : null,
                                    backgroundRepeat: "round"
                                }}
							>
								<label
									htmlFor="filepond--browser-fu3nrnhrk"
									id="filepond--drop-label-fu3nrnhrk"
									aria-hidden="true"
								>
									<i className="lnil lnil-cloud-upload" />
								</label>
							</div>
						</div>
					</div>
					{!readOnly && (
						<>
					<button
						className={`button is-circle edit-button is-edit ${show ? "is-hidden" : ""} `}
						onClick={(e) => {
							e.preventDefault();
							setShow(true);
							uploadInput.current.click()
						}}
					>
						<span className="icon is-small">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width={24}
								height={24}
								viewBox="0 0 24 24"
								fill="none"
								stroke="currentColor"
								strokeWidth={2}
								strokeLinecap="round"
								strokeLinejoin="round"
								className="feather feather-edit-2"
							>
								<path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z" />
							</svg>
						</span>
					</button>
					<button
						className={`button is-circle edit-button is-back ${ show ? "" : "is-hidden" }`}
						onClick={(e) => {
							e.preventDefault();
							setShow(false);
						}}
					>
						<span className="icon is-small">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width={24}
								height={24}
								viewBox="0 0 24 24"
								fill="none"
								stroke="currentColor"
								strokeWidth={2}
								strokeLinecap="round"
								strokeLinejoin="round"
								className="feather feather-arrow-left"
							>
								<line x1={19} y1={12} x2={5} y2={12} />
								<polyline points="12 19 5 12 12 5" />
							</svg>
						</span>
					</button>
						</>
					)}
				</div>
			</div>
		);
}


export const ValidatedInputField = (props) => {
	const [input, setInput] = React.useState();
	const [has_error, setHasError] = React.useState()

	const validate = async () => {
		if(props?.endpoint && props.value !== input){
			const res = await api.post({ endpoint: props?.endpoint, data: { username: input } });
			if(res?.status){
				 props?.callback && props?.callback(input);
				 setHasError({ type: "success", message: res?.detail||"Username is available." })
			}else{
				setHasError({ type: "error", message: res?.detail||"Username taken." })
			}
		}else{
			setHasError(null);
			props?.callback && props?.callback(input);
		}
	}

	React.useEffect(() => {
		if(input)validate()
	}, [input])

	return <BasicInputField {...props} callback={(e) => setInput(e)} has_error={has_error} />
}



export const BasicInputField = (props) => {
	const { has_error = null, value, callback, label = null } = props;

	return (
		<div className="field">
			{label &&  <label>{label}</label>}
			
			<div className={`control has-icon ${ has_error ? ` has-validation has-${ has_error?.type || "error"}` : "" } `}>
				<input
					type="text"
					className="input"
					defaultValue={value}
					onInput={(e) => callback(e.target.value)}
					readOnly={props?.readOnly}
				/>
				<div className="form-icon" dangerouslySetInnerHTML={{ __html: props?.icon }}>
				</div>
				{has_error && (
					<>
					<div className="validation-icon is-success">
						<i className="fas fa-check success-text" />
					</div>
					<div className="validation-icon is-error">
					<i className="fas fa-times danger-text" />
					</div>
					</>
				)}
			</div>
			{has_error && <p className={`help ${has_error?.type === "success"? "success":"danger"}-text`}>{has_error?.message}</p> }
		</div>
	);
};
